import React, { useContext, useEffect } from "react";
import {
  FormContainer,
  FormItem,
  InputTextFields,
  InputPhoneNumberField,
  InputSelectField,
  InputDateSelectField,
  BirthdateSelectContainer,
} from "pages/Edit/components/Form.styled";
import { CitizenEditContext } from "../CitizenEditContext";
import { daysOptions, monthsOptions, yearOptions } from "../../../../constant/selectConstants";
import civilStatusOptions from "jsonLib/civilStatuses.json";

const VerificationInformation = ({ form, formData }) => {
  const { first_name, middle_name, last_name, suffix, civil_status } = formData;

  const {
    state,
    stateDispatchMain,
    formatPhoneNumber,
    parsePhoneNumber,
    provinceOptions,
    municipalityOptions,
    barangayOption,
    setSelectedProvince,
    setSelectedMunicipality,
    selectedMunicipality,
    selectedProvince,
    isLoading,
    findCivilStatusOption,
  } = useContext(CitizenEditContext);

  const { citizenDetailsRegister } = state;

  // Use effect to set form values when citizenDetails updates
  useEffect(() => {
    if (citizenDetailsRegister) {
      form.setFieldsValue({
        first_name: citizenDetailsRegister.first_name,
        last_name: citizenDetailsRegister.last_name,
        suffix: citizenDetailsRegister.name_extension,
        year: citizenDetailsRegister.birthdate_year || null,
        month: citizenDetailsRegister.birthdate_month || null,
        date: parseInt(citizenDetailsRegister.birthdate_day, 10) || null,
        province: {
          value: citizenDetailsRegister.municipality?.province?.id || null,
          label: citizenDetailsRegister.municipality?.province?.name || "",
        },
        municipality: {
          value: citizenDetailsRegister.municipality?.id || null,
          label: citizenDetailsRegister.municipality?.name || "",
        },
        barangay: {
          value: citizenDetailsRegister.barangay?.id || null,
          label: citizenDetailsRegister.barangay?.name || "",
        },
        phone_number: citizenDetailsRegister.phone_number,
        gender: {
          value: citizenDetailsRegister.gender?.id || null,
          label: citizenDetailsRegister.gender?.name || "",
        },
        address: citizenDetailsRegister.address,
        civil_status: findCivilStatusOption(citizenDetailsRegister.civil_status),
      });
    }
  }, [citizenDetailsRegister, form]);

  useEffect(() => {
    const year = form?.getFieldValue("year");
    const month = form?.getFieldValue("month");
    const date = form?.getFieldValue("date");

    if (date) {
      const dateOptions = daysOptions(month, year);

      if (!dateOptions.find(d => d.value === date)) {
        form?.setFieldsValue({ date: undefined });
      }
    }
  }, [form?.getFieldValue("month"), form?.getFieldValue("year")]);

  return (
    <FormContainer>
      <FormItem label="Pangalan / First Name" name="first_name" rules={[{ required: true, message: "First name is required" }]}>
        <InputTextFields
          name="first_name"
          value={first_name}
          onChange={e =>
            stateDispatchMain({
              key: "citizenDetails",
              payload: {
                ...state.citizenDetails,
                first_name: e.target.value,
              },
            })
          }
        />
      </FormItem>
      <FormItem label="Gitnang Pangalan / Middle Name" name="middle_name">
        <InputTextFields
          name="middle_name"
          value={middle_name}
          onChange={e =>
            stateDispatchMain({
              key: "citizenDetails",
              payload: {
                ...state.citizenDetails,
                middle_name: e.target.value,
              },
            })
          }
        />
      </FormItem>
      <FormItem label="Apelyido / Last Name" name="last_name" rules={[{ required: true, message: "Last name is required" }]}>
        <InputTextFields
          name="last_name"
          value={last_name}
          onChange={e =>
            stateDispatchMain({
              key: "citizenDetails",
              payload: {
                ...state.citizenDetails,
                last_name: e.target.value,
              },
            })
          }
        />
      </FormItem>
      <FormItem label="Ext (Sr,Jr,I,II,III)" name="suffix">
        <InputTextFields
          name="suffix"
          value={suffix}
          onChange={e =>
            stateDispatchMain({
              key: "citizenDetails",
              payload: {
                ...state.citizenDetails,
                name_extension: e.target.value,
              },
            })
          }
        />
      </FormItem>

      <FormItem label="Birthdate">
        <BirthdateSelectContainer>
          <FormItem
            className="personal-info-date-select"
            label="Year"
            name="year"
            rules={[{ required: true, message: "Year is required." }]}>
            <InputDateSelectField
              options={yearOptions()}
              showSearch
              allowClear
              onChange={value => {
                stateDispatchMain({
                  key: "citizenDetails",
                  payload: {
                    ...state.citizenDetails,
                    birthdate_year: value,
                  },
                });
              }}
            />
          </FormItem>
          <FormItem
            className="personal-info-date-select"
            label="Month"
            name="month"
            rules={[{ required: true, message: "Month is required." }]}>
            <InputDateSelectField
              options={monthsOptions()}
              filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
              showSearch
              allowClear
              onChange={value => {
                stateDispatchMain({
                  key: "citizenDetails",
                  payload: {
                    ...state.citizenDetails,
                    birthdate_month: value,
                  },
                });
              }}
            />
          </FormItem>
          <FormItem
            className="personal-info-date-select"
            label="Date"
            name="date"
            rules={[{ required: true, message: "Date is required." }]}>
            <InputDateSelectField
              options={daysOptions(form?.getFieldValue("month"), form?.getFieldValue("year"))}
              disabled={!form?.getFieldValue("year") || !form?.getFieldValue("month")}
              showSearch
              allowClear
              onChange={value => {
                stateDispatchMain({
                  key: "citizenDetails",
                  payload: {
                    ...state.citizenDetails,
                    birthdate_day: value,
                  },
                });
              }}
            />
          </FormItem>
        </BirthdateSelectContainer>
      </FormItem>
      <FormItem
        label="Civil Status"
        name="civil_status"
        rules={[{ required: true, message: "Civil status is required" }]}>
        <InputSelectField
          showSearch
          name="civil_status"
          value={civil_status}
          bordered={false}
          optionFilterProp="children"
          onChange={value => {
            stateDispatchMain({
              key: "citizenDetails",
              payload: {
                ...state.citizenDetails,
                civil_status: value,
              },
            });
          }}
          options={civilStatusOptions}
          filterOption={(input, option) => {
            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}
        />
      </FormItem>
      <FormItem label="Probinsya" name="province" rules={[{ required: true, message: "Probinsya is required" }]}>
        <InputSelectField
          name="province"
          bordered={false}
          onChange={(_, options) => {
            stateDispatchMain({
              key: "citizenDetails",
              payload: {
                ...state.citizenDetails,
                province: {
                  value: options?.value,
                  label: options?.label,
                },
              },
            });
            setSelectedProvince(options?.value);
            form.setFieldsValue({ province: { value: options?.value, label: options?.label } });
          }}
          options={provinceOptions}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => {
            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}
        />
      </FormItem>
      <FormItem
        label="Lungsod/Munisipyo"
        name="municipality"
        rules={[{ required: true, message: "Lungsod/Munisipyo is required" }]}>
        <InputSelectField
          name="municipality"
          bordered={false}
          onChange={(_, option) => {
            stateDispatchMain({
              key: "citizenDetails",
              payload: {
                ...state.citizenDetails,
                municipality: {
                  value: option?.value,
                  label: option?.label,
                },
              },
            });
            setSelectedMunicipality(option?.value);
            form.setFieldsValue({ municipality: { value: option?.value, label: option?.label } });
          }}
          disabled={!selectedProvince}
          options={municipalityOptions}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => {
            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}
        />
      </FormItem>
      <FormItem label="Barangay" name="barangay" rules={[{ required: true, message: "Barangay is required" }]}>
        <InputSelectField
          name="barangay"
          allowClear
          bordered={false}
          onChange={(_, option) => {
            stateDispatchMain({
              key: "citizenDetails",
              payload: {
                ...state.citizenDetails,
                barangay: option?.value,
              },
            });
            form.setFieldsValue({ barangay: option });
          }}
          options={barangayOption}
          disabled={!selectedMunicipality}
          showSearch
          notFoundContent={!isLoading ? "Loading.." : "No Data"}
          optionFilterProp="children"
          filterOption={(input, option) => {
            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
          }}
        />
      </FormItem>
      <FormItem
        label="Mobile Number"
        name="phone_number"
        validateTrigger={["onBlur"]}
        rules={[
          { required: true, message: "Mobile number is required" },
          {
            validator: async (_, value) => {
              if (value.toString().length < 10) {
                return Promise.reject("Incorrect mobile number format");
              } else {
                return Promise.resolve();
              }
            },
            message: "Incorrect mobile number format",
          },
        ]}>
        <InputPhoneNumberField
          name="phone_number"
          autoComplete="off"
          formatter={formatPhoneNumber}
          parser={parsePhoneNumber}
          onChange={value => {
            stateDispatchMain({
              key: "citizenDetails",
              payload: {
                ...state.citizenDetails,
                phone_number: value,
              },
            });
          }}
          onKeyPress={event => {
            if (!/[0-9]/.test(event.key)) {
              event.preventDefault();
            }
          }}
          defaultValue={63}
          maxLength={12}
          minLength={12}
        />
      </FormItem>
    </FormContainer>
  );
};

export default VerificationInformation;
